import sharedConstants from "@lib/shared_constants";

export const engagementSendOutcomesAbortLogData =
  "/:app_group_id/messaging_diagnostics/send_outcomes_abort_log" as const;

/** `code` on an abort log error response when the query hit a server resource limit */
export const resourceLimitExceededErrorCode = "resource_limit_exceeded";

export const sendOutcomesEventCategories = [
  "in_progress",
  "delivery_and_engagement",
  "suppressions",
  "errors_and_failures",
  "account_and_data_health",
  "other",
] as const;

export const abortLogChannels = [
  sharedConstants.CHANNELS.EMAIL,
  sharedConstants.CHANNELS.SMS,
  sharedConstants.CHANNELS.IOS_PUSH,
  sharedConstants.CHANNELS.ANDROID_PUSH,
  sharedConstants.CHANNELS.WEB_PUSH,
  sharedConstants.CHANNELS.KINDLE_PUSH,
  sharedConstants.CHANNELS.CONTENT_CARDS,
  sharedConstants.CHANNELS.WEBHOOK,
  sharedConstants.CHANNELS.TRIGGER_IN_APP_MESSAGE,
  sharedConstants.CHANNELS.BANNER,
  sharedConstants.CHANNELS.LINE,
  sharedConstants.CHANNELS.WHATS_APP,
] as const;
